/* eslint-disable */
export default {
  dncAlert: 'Este contacto está en una Lista de no llamar.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
